import { isWriteBlockedByLicense } from "../../entity/company-license";

/**
 * Barra, na tela, a escrita de empresa sem licença — criar ou editar cenário, orçamento e
 * projeção, e mexer na parametrização.
 *
 * A recusa de verdade vive na API (`assertCompanyCanWrite`, no data-engine): o v1 não tem guard de
 * rota, então a URL direta abre a tela de qualquer jeito. Aqui o objetivo é outro — dizer o motivo
 * antes de o usuário chegar ao erro, e oferecer o caminho, que é ativar a empresa.
 *
 * Um diálogo, e não um toast: é o padrão da casa para barrar ação com explicação (o mesmo do
 * `use-inactive-company-gate` no v2).
 */
export class CompanyLicenseWriteGuard {
    /** `$mdDialog` é obrigatório — ver o comentário na ação do botão. */
    constructor({ DSNDialogService, $mdDialog } = {}) {
        this.DSNDialogService = DSNDialogService;
        this.$mdDialog = $mdDialog;
    }

    isBlocked(companyData) {
        return isWriteBlockedByLicense({ companyProps: companyData });
    }

    /**
     * Devolve `true` quando a ação foi barrada — o chamador deve parar aí.
     *
     * A ação é nomeada na mensagem porque a mesma trava atende telas diferentes, e "não é possível
     * alterar" sem dizer o quê deixa o contador procurando o que ele fez de errado.
     */
    block({ companyData, acao = "alterar esta informação", $event } = {}) {
        if (!this.isBlocked(companyData)) return false;

        this.DSNDialogService.confirmation({
            targetEvent: $event,
            locals: {
                destructive: false,
                title: "Empresa inativa",
                description: `Para ${acao}, é preciso ativar a empresa. Enquanto decide, você continua podendo navegar pelo cadastro, pelos inputs e pela leitura consultiva.`,
                actions: {
                    confirm: {
                        // `$mdDialog` é OBRIGATÓRIO aqui: o template do confirmation
                        // (`dialog-confirmation.dialog.html`) só chama a ação e não fecha nada —
                        // sem ele o botão primário não faz coisa alguma e o usuário fica preso no
                        // diálogo. O `?.` é rede, não permissão: quem chama tem que injetar.
                        label: "Entendi",
                        action: () => this.$mdDialog?.cancel()
                    }
                }
            },
            after: {
                hide: () => {},
                cancel: () => {}
            }
        });
        return true;
    }
}
